module.exports = __webpack_public_path__ + "static/media/avatar.d6e773fc.jpg";